export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 12;
export const API_KEY = '9c056d83-0319-48b7-855f-e22778189cc0';
export const MODAL_CLOSE_SEC = 1.5;